import React from "react";
import { withPrefix } from "gatsby-link";

import "./video.scss";

const Video = ({ data, onClick }) => {
  const { videoId, title, client, role, img } = data;
  return (
    <div className={`video-item`}>
      <div className={`video-item__btn`} onClick={() => onClick(videoId)}>
        <img src={withPrefix(img)} className={"video-item__img"} />
        <div className={"video-item__content"}>
          <div className={"video-item__meta"}>
            {client && <span className={"video-item__client"}>{client}</span>}
            {title && <span className={"video-item__title"}>{title}</span>}
          </div>
          {role && <span className={"video-item__role"}>{role}</span>}
        </div>
      </div>
    </div>
  );
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/index.js